import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "motion/react";

export default function NavLinks({
  NAV_LINKS,
  LINKS,
  handleClick,
  setShowNavigation,
  linkRefs,
  activeLink,
}) {
  const { t } = useTranslation("translation", { keyPrefix: "navigation" });

  return NAV_LINKS.map((link, index) => (
    <li
      key={index + LINKS.length}
      ref={(link) => (linkRefs.current[index + LINKS.length] = link)}
      onClick={() => handleClick(index + LINKS.length)}
    >
      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }}>
        <NavLink
          className={`header-navbar__link ${activeLink === index + LINKS.length ? "active" : ""}`}
          onClick={() => setShowNavigation(false)}
          to={`/${link.name}`}
        >
          {t(link.name)}
        </NavLink>
      </motion.div>
    </li>
  ));
}
